/* eslint-disable import/no-anonymous-default-export */
export default (received = [], action) => {
  switch (action.type) {
    case "GET_ALL_STOCK_RECEIVED":
      return action.payload;

    case "CREATE_STOCK_RECEIVED":
      return [...received, action.payload];

    default:
      return received;
  }
};
